import {Component, OnInit, OnDestroy, ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { Log } from "ng2-logger";
import { ToolRequestsService } from "@services/tool-requests.service";
import { TableConfig } from "@app/shared/util/table-config.utils";
import { ToolRequest } from "@models/toolRequests.model";
import { Tool } from "@app/tool/model/tool.model";
import { TranslateService } from "@ngx-translate/core";
import { ToastsManager } from "@app/shared/util/toastr.service";
import { Location } from "@angular/common";
import { Subscription } from 'rxjs';
import { ObservableService } from '@app/core/services/observable.service';
import {ToolRequestFacilitiesToolsTableComponent} from "@app/roles/atom-operator/pages/tool-requests-facilities/components";

@Component({
    selector: 'app-process-tool-requests-facilities',
    templateUrl: './process-tool-requests-facilities.component.html',
    styleUrls: ['./process-tool-requests-facilities.component.scss']
})
export class ProcessToolRequestsFacilitiesComponent implements OnInit, OnDestroy {

    @ViewChild(ToolRequestFacilitiesToolsTableComponent, {static: false}) table: ToolRequestFacilitiesToolsTableComponent;

    _logger = Log.create(ProcessToolRequestsFacilitiesComponent.name);

    tableConfig = new TableConfig();
    isLoading = false;
    hasConfirmationInProgress = false;

    selectedToolRequestDetails;
    selectedToolRequestTools: Tool[];
    observableServiceSubscription: Subscription;
    private _toolRequestId: number;

    showFilters = true;
    allExpanded = false;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private toastr: ToastsManager,
                private location: Location,
                private translateService: TranslateService,
                private toolRequestService: ToolRequestsService,
                observableService: ObservableService) {
        this.observableServiceSubscription = observableService.hasChanged$.subscribe(
            () => {
                this.getToolRequestDetails(this._toolRequestId);
                this.getToolRequestTools(this._toolRequestId);
            }
        )
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this._toolRequestId = params['id'];
            this.getToolRequestDetails(this._toolRequestId);
            this.getToolRequestTools(this._toolRequestId);
        });
    }

    ngOnDestroy() {
        this.observableServiceSubscription.unsubscribe();
    }

    onBack() {
        this.location.back();
    }

    getToolRequestDetails(id: number) {
        this.toolRequestService.getToolRequestDetails(id).subscribe(
            (data: ToolRequest) => {
                this._logger.info('getTolRequestDetails:: API Returned data', data);
                this.selectedToolRequestDetails = data;
            },
            (error) => {
                this._logger.info('getTolRequestDetails:: API Returned error', error);
            }
        );
    }

    getToolRequestTools(id: number, tableConfig = new TableConfig()) {
        tableConfig.pager.pageSize = 0;
        this.toolRequestService.getToolRequestTools(id, tableConfig).subscribe(
            (data) => {
                this._logger.info('getToolRequestTools:: API Returned data', data);
                this.selectedToolRequestTools = data.items;
                this.tableConfig.pager.count = data.total || 0;
            },
            (error) => {
                this._logger.info('getToolRequestTools:: API Returned error', error);
            }
        );
    }

    approveToolRequest() {
        this.hasConfirmationInProgress = true;
        this._logger.info("approve:: Approved tool request");
        this.toolRequestService.approveToolRequestById(this.selectedToolRequestDetails.id).subscribe(
            (data) => {
                this.hasConfirmationInProgress = false;
                this._logger.info('approve:: Tool request approved', data);
                this.router.navigate([`tool-requests-facilities`]);
                this.toastr.success(this.buildApprovalMessage(this.selectedToolRequestDetails.name));
            },
            (error) => {
                this.hasConfirmationInProgress = false;
                this._logger.info('getToolRequestTools:: API Returned error', error);
                this.toastr.error(this.buildServerError(this.selectedToolRequestDetails.name));
            }
        );
    }

    buildApprovalMessage(toolRequestName) {
        return this.translateService.instant('atom.tool-requests-facilities.toasts.toolRequestApproved',
            {toolRequestName: toolRequestName});
    }

    buildServerError(toolRequestName) {
        return this.translateService.instant('atom.tool-requests-facilities.toasts.cannotProcess',
            {toolRequestName: toolRequestName})
    }


    onSortChange(tableConfig) {
        this._logger.info("onSortChange::", tableConfig);
        this.getToolRequestTools(this.selectedToolRequestDetails.id, this.tableConfig);
    }

    onFilter(tableConfig) {
        this._logger.info("onFilter::", tableConfig);
        this.getToolRequestTools(this.selectedToolRequestDetails.id, this.tableConfig);
    }

    onPageChange(tableConfig) {
        this._logger.info("onPageChange::", tableConfig);
        this.getToolRequestTools(this.selectedToolRequestDetails.id, this.tableConfig);
    }

    toggleFilters() {
        this.showFilters = !this.showFilters;
    }

    toggleExpanded() {
        this.allExpanded = !this.allExpanded;
        this.table.toggleExpand(this.allExpanded);
    }
}
